import {TypographyProps} from '@mui/material'
import {Typography} from './Typography'

export const BodySmall = ({...props}: Omit<TypographyProps, 'variant'>) => {
    return <Typography variant="body-small" {...props}/>
}